import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d90e621c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "list-head"
};
var _hoisted_2 = {
  class: "songer-head"
};
var _hoisted_3 = {
  class: "left-title"
};
var _hoisted_4 = {
  class: "title-box"
};
var _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 头部分类盒子 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftTitle, function (item1, index1) {
    return _openBlock(), _createElementBlock("div", {
      class: "songer-title",
      key: item1
    }, [_createCommentVNode(" 左边分类 "), _createElementVNode("div", _hoisted_3, _toDisplayString(item1) + "：", 1
    /* TEXT */
    ), _createCommentVNode(" 右边分类 "), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightTitle[index1], function (item2) {
      var _item2$id;

      return _openBlock(), _createElementBlock("div", {
        key: item2.id,
        class: _normalizeClass({
          'title-text': true,
          active: ((_item2$id = item2.id) !== null && _item2$id !== void 0 ? _item2$id : item2) == _ctx.tag[index1]
        }),
        onClick: function onClick($event) {
          return _ctx.titleClick(index1, item2);
        }
      }, [_createElementVNode("span", null, _toDisplayString(item2.title || item2), 1
      /* TEXT */
      )], 10
      /* CLASS, PROPS */
      , _hoisted_5);
    }), 128
    /* KEYED_FRAGMENT */
    ))])]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}